/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".icon-tooltip[_ngcontent-%COMP%]{display:inline-block;--tooltip-left-before-left:94.5%;--tooltip-right-before-left:-10%}.subtitle[_nghost-%COMP%]   .icon-tooltip[_ngcontent-%COMP%], .subtitle   [_nghost-%COMP%]   .icon-tooltip[_ngcontent-%COMP%]{vertical-align:sub}"];
export { styles as styles };
